import clsx from 'clsx'
import React from 'react'
import { Translation } from '../../contexts/TranslationContext'
import SvgWarningTriangle from '../../svg/icons/WarningTriangle'
import style from './Rating.module.sass'

type RatingProps = {
	rateAmount: number | null | undefined
	isPlacedInComparator?: boolean
	isPlacedOnProductDetail?: boolean
	hideText?: boolean
	disabled?: boolean
}

export const Rating = React.memo(function Rating(props: RatingProps) {
	const round = (number: number, increment: number, offset: number) => {
		return Math.ceil((number - offset) / increment) * increment + offset
	}

	const starAmountRounded = round(Number(props.rateAmount), 10, 10) / 20
	const widthOfFilterStars = 28 * Number(starAmountRounded) /* 28px width of a star to Filter view */

	return (
		<>
			{typeof props.rateAmount === 'number' && props.rateAmount < 0 ? (
				<div className={clsx(style.emptyRoot, props.isPlacedInComparator && style.emptyRootFormatted)}>
					<div className={style.emptyNumber}>
						<SvgWarningTriangle />
					</div>
					<div className={style.emptyText}>
						<Translation tr="RatingEmpty.text" />
					</div>
				</div>
			) : (
				<div
					className={clsx(
						style.wrapper,
						props.isPlacedInComparator && style.wrapperComparator,
						props.hideText && style.wrapperHiddenText,
					)}
				>
					{!props.hideText && (
						<span
							className={clsx(
								style.ratingNumber,
								typeof props.rateAmount === 'number' && props.rateAmount === 0 && style.ratingNumberHighlighted,
								props.isPlacedInComparator && style.ratingNumberComparator,
								props.isPlacedOnProductDetail && style.ratingNumberProductDetail,
							)}
						>
							{props.rateAmount}&nbsp;%
						</span>
					)}
					{Number(props.rateAmount) > 0 ? (
						<div
							className={clsx(
								style.starRating,
								props.isPlacedInComparator && style.starRatingComparator,
								props.hideText && style.starRatingHiddenBackground,
								props.disabled && style.starRatingDisabled,
							)}
							style={props.hideText ? { width: widthOfFilterStars } : undefined}
						>
							<span style={{ width: props.hideText ? '100%' : `${props.rateAmount}%` }} />
						</div>
					) : (
						<div className={clsx(style.starRating, props.isPlacedInComparator && style.starRatingComparator)}>
							<span style={{ width: '0%' }} />
						</div>
					)}
				</div>
			)}
		</>
	)
})
Rating.displayName
